import styled from "styled-components";
export var Bold = styled.b.withConfig({
  displayName: "Bold"
})(["font-weight:500;"]);